import React from 'react';
import AccountIcon from './accountIcon';
import LockIcon from './lockIcon';
import SchoolIcon from './schoolIcon';
import EditIcon from './editIcon';
import PdotComLogo from './pdotcomlogo';
import PPlusLogo from './pPlusLogo';
import ReskinLogo from './reskinLogo';

interface SvgIconProps {
  name: string;
  classes?: string;
  color?: string;
}

const getIconDetail = (name: string, props: any) => {
  const icon = {
    component: <div />,
    viewBox: '',
  };
  switch (name) {
    case 'ACCOUNT':
      icon.component = <AccountIcon {...props} />;
      icon.viewBox = '0 0 24 24';
      break;
    case 'SCHOOL':
      icon.component = <SchoolIcon {...props} />;
      icon.viewBox = '0 0 25.29 30.49';
      break;
    case 'LOCK':
      icon.component = <LockIcon {...props} />;
      icon.viewBox = '0 0 24 24';
      break;
    case 'EDIT':
      icon.component = <EditIcon {...props} />;
      icon.viewBox = '0 0 18 18';
      break;
    case 'PDOTCOMLOGO':
      icon.component = <PdotComLogo {...props} />;
      icon.viewBox = '0 0 119 34';
      break;
    case 'RESKINLOGO':
      icon.component = <ReskinLogo {...props} />;
      icon.viewBox = '0 0 120 24';
      break;
    case 'PPLUSLOGO':
      icon.component = <PPlusLogo {...props} />;
      icon.viewBox = '0 0 134 34';
      break;
    default:
      icon.component = <path {...props} />;
      icon.viewBox = '0 0 18 18';
      break;
  }

  return icon;
};

function SvgIcon({ name, color, classes }: SvgIconProps) {
  const { component, viewBox } = getIconDetail(name, { color });

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox={viewBox} className={classes}>
      {component}
    </svg>
  );
}

export default SvgIcon;
